import { Divider, Form, Input, Spin, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../../../features/save/saveSlice";
import svg44 from "../../../../../../assets/svg/svg44.svg";
import svg45 from "../../../../../../assets/svg/svg45.svg";
import svg46 from "../../../../../../assets/svg/svg46.svg";
import svg40 from "../../../../../../assets/svg/svg40.svg";
import toast from "react-hot-toast";
import {
  fetchData,
  fetchFiles,
} from "../../../../../../features/fetch/fetchSlice";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import DocumentAdd from "./DocumentAdd";
import ConfirmModal from "../../../../../../components/ConfirmModal";
import ConfirmDesignModal from "../../../../../../components/ConfirmDesignModal copy";

const { TextArea } = Input;
function Design({ handleNext, handleBack }) {
  const { open, handleCancel, handleOpen } = useModalToggle();
  const url = "api/v2/projectFiles/get";
  const urlSingle = "api/v2/main_projects/get";
  const { saving } = useSelector((state) => state.save);
  const { loading, data, count, activeObjPlannedProject, dataProjSingle } =
    useSelector((state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjPlannedProject: state.obj.activeObj["plannedProject"],
      dataProjSingle: state.fetch.data[urlSingle] || [],
    }));

  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [prodd, setProdd] = useState();
  const [prodd1, setProdd1] = useState();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/projectFiles/delete",
        pfId: prodd?.pfId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleOpenDocAtt = async (item) => {
    await setProdd1(item);
    await handleOpen();
  };

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFiles({ file: item }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  const columns = [
    {
      title: "Design Documents",
      dataIndex: "pfFileName",
      render: (item) => {
        return (
          <div className="cursor-pointer flex items-center gap-x-[.65rem]">
            {" "}
            <img src={svg44} alt="svg44" /> {item}
          </div>
        );
      },
    },

    {
      title: (
        <div
          className="p-[.5rem] w-[2rem] h-[2rem] flex items-center justify-center rounded-[0.375rem] border border-[#D6E1F5] bg-white cursor-pointer"
          onClick={() => handleOpenDocAtt("DESIGN_DOCUMENT")}
        >
          <img src={svg40} alt="svg40" />
        </div>
      ),
      width: "10px",
      render: (item) => {
        return (
          <div
            className="flex items-center gap-x-[.62rem] "
            onClick={() => setProdd(item)}
          >
            <img
              src={svg45}
              alt="svg45"
              className="cursor-pointer"
              onClick={() => downloadFile(item?.pfFilePath)}
            />
            <img
              className="cursor-pointer"
              src={svg46}
              alt="svg46"
              onClick={() => handleOpenDelete()}
            />
          </div>
        );
      },
    },
  ];
  const columns1 = [
    {
      title: "Bill of Quantities",
      dataIndex: "pfFileName",
      render: (item) => {
        return (
          <div className="cursor-pointer flex items-center gap-x-[.65rem]">
            {" "}
            <img src={svg44} alt="svg44" /> {item}
          </div>
        );
      },
    },

    {
      title: (
        <div
          className="p-[.5rem] w-[2rem] h-[2rem] flex items-center justify-center rounded-[0.375rem] border border-[#D6E1F5] bg-white cursor-pointer"
          onClick={() => handleOpenDocAtt("BILL_OF_QUANTITIES")}
        >
          <img src={svg40} alt="svg40" />
        </div>
      ),
      width: "10px",
      render: (item) => {
        return (
          <div
            className="flex items-center gap-x-[.62rem] "
            onClick={() => setProdd(item)}
          >
            <img
              src={svg45}
              alt="svg45"
              className="cursor-pointer"
              onClick={() => downloadFile(item?.pfFilePath)}
            />
            <img
              className="cursor-pointer"
              src={svg46}
              alt="svg46"
              onClick={() => handleOpenDelete()}
            />
          </div>
        );
      },
    },
  ];

  const handlePrev = () => {
    handleBack();
  };
  const [confirmData, setConfirmData] = useState(null);
  const [openDesignAppr, setOpenDesignAppr] = useState(false);

  const onFinish = async (data) => {
    setConfirmData(data);
    setOpenDesignAppr(true);
  };

  const handleYes = async () => {
    await setOpenDesignAppr(false);
    const res = await dispatch(
      save({
        projectDesignApproval: "Yes",
        designDescription: confirmData?.designDescription,
        projectId: activeObjPlannedProject?.projectId,
        url: "api/v2/main_projects/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message); 
      await handleNext();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleNo = async () => {
    await setOpenDesignAppr(false);
    const res = await dispatch(
      save({
        projectDesignApproval: "No",
        projectId: activeObjPlannedProject?.projectId,
        url: "api/v2/main_projects/save",
      })
    );
    if (res?.payload?.success) {
      await fetchProjData()
    } else {
      toast.error(res?.payload?.message);
    } 
    await toast.error(
      "Sorry! You cannot move to the next step before your designs are approved. Kindly take your documents for the projects for approval to the relevant offices.",
      {
        position: "top-center",
        autoClose: false,
        style: {
          background: "#475569",
          color: "#fff",
          width: "100%",
          maxWidth: "100%",
          borderRadius: "0px",
          marginLeft: "15%",
          marginRight: "1%",
        },
      }
    );
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        pfFileCategory: "DESIGN",
        pfProjectId: activeObjPlannedProject?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  const designData = data?.filter(
    (item) => item?.pfFileDescription === "DESIGN_DOCUMENT"
  );
  const billData = data?.filter(
    (item) => item?.pfFileDescription === "BILL_OF_QUANTITIES"
  );

  async function fetchProjData() {
    await dispatch(
      fetchData({
        url: urlSingle,
        projectId: activeObjPlannedProject?.projectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    fetchProjData();
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      designDescription: dataProjSingle?.[0]?.designDescription,
    });
  }, [dataProjSingle]);
 
  return (
    <>
      <div className="flex lg:item-center lg:flex-row flex-col gap-[1.25rem]  min-h-[45vh] justify-between">
        <div className="w-full">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
          >
            <Form.Item
              name="designDescription"
              label={"Describe the design process"}
              rules={[
                {
                  required: true,
                  message: "Please describe the design process",
                },
              ]}
            >
              <TextArea
                placeholder="Description"
                rows={7}
                className="text_area"
              />
            </Form.Item>
          </Form>
        </div>
        <div className="w-full">
          <Table
            rowSelection={false}
            className="w-full"
            scroll={{
              x: "auto",
            }}
            rowKey={(record) => record?.pfId}
            columns={columns}
            dataSource={designData}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />

          <Table
            rowSelection={false}
            className="w-full"
            scroll={{
              x: "auto",
            }}
            rowKey={(record) => record?.pfId}
            columns={columns1}
            dataSource={billData}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>
      <div className="sticky bottom-0 left-0 w-full">
        <Divider />
        <div className="flex justify-end mt-[1rem] gap-x-[1.25rem]">
          <div className="w-[100px]">
            <button
              type="button"
              key="back"
              className="cstm-btn"
              onClick={handlePrev}
            >
              Back
            </button>
          </div>

          <div className="w-[100px]">
            <button
              onClick={() => form.submit()}
              disabled={saving}
              type="button"
              className="cstm-btn-2"
            >
              {saving ? <Spin /> : "Next"}
            </button>
          </div>
        </div>
      </div>

      <DocumentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
        prodd1={prodd1}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />

      <ConfirmDesignModal
        open={openDesignAppr}
        handleCancel={handleNo}
        handleSubmit={handleYes}
        loading={loading}
        content="Are these projects design approved ?"
        type="info"
        btnTitle="Yes"
        btnCancel="No"
      />
    </>
  );
}

export default Design;
